import { UserDonateLog } from "@interfaces/user/users";
import { createContext, useContext } from "react";

const DonateLogItemContext = createContext<UserDonateLog>(undefined as any);
export const DonateLogItemProvider = DonateLogItemContext.Provider;

export function useDonateLogItemContext(): UserDonateLog | undefined {
    return useContext(DonateLogItemContext);
}